import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import ChatbotWidget from './en/components/Chatbot/ChatbotWidget';

// EN pages
import EnHome from './en/pages/Home.js';
import EnMainHeader from './en/components/nav/MainHeader';
import EnAbout from './en/pages/About.js';
import EnContact from './en/pages/Contact.js';
import EnSuccessStory1 from './en/pages/success-story-1.js';
import EnSuccessStory2 from './en/pages/success-story-2.js';
import EnSuccessStory3 from './en/pages/success-story-3.js';
import EnSuccessStory4 from './en/pages/success-story-4.js';
import EnSuccessStory5 from './en/pages/success-story-5.js';
import EnSuccessStory6 from './en/pages/success-story-6.js';
import EnCareer from './en/pages/Career.jsx';
import EnJobDetail from './en/pages/jobdetail/JobDetail.jsx';
import EnSecurityAssessment from './en/pages/SecurityAssessment.js';
import EnAllBlogs from './en/components/blog/AllBlogs.js';
import EnBlogDetail from './en/components/blog/CompleteHtmlBlogDetail.js';
import EnManagedServices from './en/pages/services/ManagedServices.js';
import EnCoManagedIT from './en/pages/services/CoManagedITServices.js';
import EnServerAdmin from './en/pages/services/ServerAdministration.js';
import EnAppDev from './en/pages/services/ApplicationDevelopment.js';
import EnVAPT from './en/pages/services/VAPTAssessment.js';
import EnNetworkMonitoring from './en/pages/services/NetworkMonitoring.js';
import EnERPSolutions from './en/pages/services/ERPSolutions.js';
import EnServicePlans from './en/pages/services/ServicePlans.js';
import EnWhyChooseUs from './en/pages/services/WhyChooseUs.js';
import EnMedia from './en/components/individual/Media.js';
import EnFAQ from './en/pages/FAQ.jsx';
import EnLifeAtDg from './en/pages/LifeAtDg.js';
import EnPrivacyPolicy from './en/pages/PrivacyPolicy.js';
import EnScrollToTop from './en/components/ScrollToTop';
import EnCookieConsent from './en/components/CookieConsent.js';

// JP pages
import JpHome from './jp/pages/Home';
import JpMainHeader from './jp/components/nav/MainHeader';
import JpCampaignPage from './jp/pages/Campaignbannerpage.js';
import JpAbout from './jp/pages/About';
import JpContact from './jp/pages/Contact';
import JpSuccessStory1 from './jp/pages/success-story-1';
import JpSuccessStory2 from './jp/pages/success-story-2';
import JpSuccessStory3 from './jp/pages/success-story-3';
import JpSuccessStory4 from './jp/pages/success-story-4';
import JpSuccessStory5 from './jp/pages/success-story-5';
import JpSecurityAssessment from './jp/pages/SecurityAssessment';
import JpManagedServices from './jp/pages/services/ManagedServices';
import JpCoManagedIT from './jp/pages/services/CoManagedITServices';
import JpServerAdmin from './jp/pages/services/ServerAdministration';
import JpAppDev from './jp/pages/services/ApplicationDevelopment';
import JpVAPT from './jp/pages/services/VAPTAssessment';
import JpNetworkMonitoring from './jp/pages/services/NetworkMonitoring';
//import JpServicePlans from './jp/pages/services/ServicePlans';
import JpWhyChooseUs from './jp/pages/services/WhyChooseUs';
import JpMedia from './jp/components/individual/Media';
import JpFAQ from './jp/pages/FAQ';
import JpLifeAtDg from './jp/pages/LifeAtDg';
import JpCompanyProfile from './jp/pages/CompanyProfile';
import JpPrivacyPolicy from './jp/pages/PrivacyPolicy';
import JpScrollToTop from './jp/components/ScrollToTop';
import JpCookieConsent from './jp/components/CookieConsent';


// Layout components
const EnLayout = () => (
  <>
    <EnScrollToTop />
    <EnCookieConsent />
    <EnMainHeader />
    {/* <ChatbotWidget 
      apiUrl="http://localhost:5000/api/chat"/>
    */}
  </> 
);

const JpLayout = () => (
  <>
    <JpScrollToTop />
    <JpCookieConsent />
    <JpMainHeader />
  </>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ── ENGLISH ── */}
        <Route path="/en" element={<EnLayout />}>
          <Route index element={<EnHome />} />
          <Route path="about" element={<EnAbout />} />
          <Route path="contact" element={<EnContact />} />
          <Route path="managed-services" element={<EnManagedServices />} />
          <Route path="co-managed-it-services" element={<EnCoManagedIT />} />
          <Route path="infrastructuremanagement" element={<EnServerAdmin />} />
          <Route path="application-development" element={<EnAppDev />} />
          <Route path="vapt-assessment" element={<EnVAPT />} />
          <Route path="networkmonitoring" element={<EnNetworkMonitoring />} />
          <Route path="erp-solutions" element={<EnERPSolutions />} />
          <Route path="serviceplans" element={<EnServicePlans />} />
          <Route path="why-choose-us" element={<EnWhyChooseUs />} />
          <Route path="success-story-finTech" element={<EnSuccessStory1 />} />
          <Route path="success-story-retailBanking" element={<EnSuccessStory2 />} />
          <Route path="success-story-digitalPayment" element={<EnSuccessStory3 />} />
          <Route path="success-story-loanEnquiry" element={<EnSuccessStory4 />} />
          <Route path="success-story-webapp" element={<EnSuccessStory5 />} />
          <Route path="success-story-erp-solutions" element={<EnSuccessStory6 />} />
          <Route path="career" element={<EnCareer />} />
          <Route path="career/jobs/:id" element={<EnJobDetail />} />
          <Route path="SecurityAssessment" element={<EnSecurityAssessment />} />
          <Route path="blogs" element={<EnAllBlogs />} />
          <Route path="blog/:id" element={<EnBlogDetail />} />
          <Route path="media" element={<EnMedia />} />
          <Route path="life-at-dg" element={<EnLifeAtDg />} />
          <Route path="faq" element={<EnFAQ />} />
          <Route path="privacy-policy" element={<EnPrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/en" replace />} />
        </Route>

        {/* ── JAPANESE ── */}
        <Route path="/jp" element={<JpLayout />}>
          <Route index element={<JpHome />} />
          <Route path="home" element={<JpHome />} />
          <Route path="campaign-page" element={<JpCampaignPage />} />
          <Route path="companyprofile" element={<JpCompanyProfile />} />
          <Route path="about" element={<JpAbout />} />
          <Route path="contact" element={<JpContact />} />
          <Route path="managed-services" element={<JpManagedServices />} />
          <Route path="co-managed-it-services" element={<JpCoManagedIT />} />
          <Route path="infrastructuremanagement" element={<JpServerAdmin />} />
          <Route path="application-development" element={<JpAppDev />} />
          <Route path="vapt-assessment" element={<JpVAPT />} />
          <Route path="networkmonitoring" element={<JpNetworkMonitoring />} />
          {/* <Route path="serviceplans" element={<JpServicePlans />} /> */}
          <Route path="why-choose-us" element={<JpWhyChooseUs />} />
          <Route path="success-story-finTech" element={<JpSuccessStory1 />} />
          <Route path="success-story-retailBanking" element={<JpSuccessStory2 />} />
          <Route path="success-story-digitalPayment" element={<JpSuccessStory3 />} />
          <Route path="success-story-loanEnquiry" element={<JpSuccessStory4 />} />
          <Route path="success-story-webApplication" element={<JpSuccessStory5 />} />
          <Route path="SecurityAssessment" element={<JpSecurityAssessment />} />
          <Route path="media" element={<JpMedia />} />
          <Route path="life-at-dg" element={<JpLifeAtDg />} />
          <Route path="faq" element={<JpFAQ />} />
          <Route path="privacy-policy" element={<JpPrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/jp" replace />} />
        </Route>

        {/* Global fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes> 
    </BrowserRouter>
  );
}
